module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_24.41d59c33.jpg";